import { Component, Fragment } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Icon from 'components/Icon';

import { isMobile, isTablet } from 'helpers/is';

import HeaderSubMenu from './HeaderSubMenu';

class Header extends Component {
  state = {
    isBurgerOpened: false,
    isMobile: isMobile(),
    isBurger: document.body.clientWidth < 768,
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
    document.body.classList.remove('_mobile-menu-is-open');
  }

  handleWindowResize = () => {
    if (this.state.isTablet !== isTablet()) {
      this.setState((prevState) => ({ isTablet: !prevState.isTablet }));
    }

    if (this.state.isBurger !== document.body.clientWidth < 768) {
      this.setState((prevState) => ({ isBurger: !prevState.isBurger }));
    }
  };

  componentDidUpdate(prevProps) {
    if (!this.props.isMobile) {
      return;
    }

    if (this.props.path !== prevProps.path) {
      this.setState({ isBurgerOpened: false }, () => {
        document.body.classList.remove('_mobile-menu-is-open');
      });
    }
  }

  handleBurgerClick = () => {
    if (this.state.isBurger) {
      this.setState(
        (prevState) => ({
          isBurgerOpened: !prevState.isBurgerOpened,
        }),
        () => {
          this.state.isBurgerOpened
            ? document.body.classList.add('_mobile-menu-is-open')
            : document.body.classList.remove('_mobile-menu-is-open');
        }
      );
    }
  };

  render() {
    const { isBurger, isBurgerOpened, isMobile } = this.state;
    const locationState = this.props.location.state;

    return (
      <Fragment>
        <div className="header-wrap">
          <header
            className={cx('header', {
              header_opened: this.state.isBurgerOpened,
            })}
          >
            <div className="wrapper header__wrapper">
              <div className="header__box">
                <div className="header__mobile-elements">
                  <div className="burger" onClick={this.handleBurgerClick}>
                    <div className="burger__elements-wrap">
                      <span className="burger__element burger__element_top" />
                      <span className="burger__element burger__element_middle" />
                      <span className="burger__element burger__element_bottom" />
                    </div>
                  </div>
                  <Link
                    className="logo header__logo header__logo_mobile"
                    to="/"
                  >
                    <Icon
                      className="header__logo-icon header__logo-icon_mobile"
                      icon="logo-mobile"
                    />
                  </Link>
                  <Link
                    to="/login"
                    className="header__login-btn header__login-btn_mobile"
                  >
                    Login
                  </Link>
                </div>
                <Link className="logo header__logo header__logo_desktop" to="/">
                  <Icon icon="logo" />
                </Link>
                <nav className="header__nav">
                  <HeaderSubMenu
                    isMobile={isMobile}
                    isBurger={isBurger}
                    isBurgerOpened={isBurgerOpened}
                    closeBurger={this.handleBurgerClick}
                  />
                  <div className="header__nav-item">
                    <Link
                      to="/features"
                      className="header__nav-link"
                      onClick={this.handleBurgerClick}
                    >
                      Features
                    </Link>
                  </div>
                  <div className="header__nav-item header__nav-item_last">
                    <Link
                      to="/templates"
                      className="header__nav-link"
                      onClick={this.handleBurgerClick}
                    >
                      Templates
                    </Link>
                  </div>
                </nav>
                <div className="header__login-wrap">
                  <Link
                    to={{
                      pathname: '/login',
                      state: locationState,
                    }}
                    className="header__login-btn"
                  >
                    Login
                  </Link>
                </div>
              </div>
            </div>
          </header>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(Header);
